import React from 'react';
import './data-source-modal.styles.css';

interface DataSourceModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  dataSource: 'api' | 'calculated' | 'mock';
  records?: any[];
  explanation?: string;
  apiUrl?: string;
}

export const DataSourceModal: React.FC<DataSourceModalProps> = ({
  isOpen,
  onClose,
  title,
  dataSource,
  records,
  explanation,
  apiUrl
}) => {
  if (!isOpen) return null;

  const sourceInfo = {
    api: {
      color: 'var(--status-success-text)',
      bg: '#dcfce7',
      label: '✓ Direct from API',
      description: 'This data comes directly from the API endpoint without any transformation.'
    },
    calculated: {
      color: 'var(--brand-primary-active)',
      bg: '#dbeafe',
      label: '≈ Calculated',
      description: 'This data is calculated/derived from API data using business logic.'
    },
    mock: {
      color: 'var(--status-warning-text)',
      bg: '#fef3c7',
      label: '⚠ Mock Data',
      description: 'This data cannot be inferred from the API and uses placeholder values.'
    }
  };

  const info = sourceInfo[dataSource];

  return (
    <div className="ds-modal modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="data-source-info" style={{ background: info.bg, color: info.color }}>
            <strong>{info.label}</strong>
            <p>{info.description}</p>
          </div>

          {apiUrl && dataSource === 'api' && (
            <div className="api-url-box">
              <strong>API Endpoint:</strong>
              <code style={{
                display: 'block',
                marginTop: '8px',
                padding: '8px 12px',
                background: 'var(--surface-sunken)',
                borderRadius: '4px',
                fontSize: '12px',
                color: 'var(--text-strong)',
                wordBreak: 'break-all',
                fontFamily: 'monospace'
              }}>
                {apiUrl}
              </code>
            </div>
          )}

          {explanation && (
            <div className="explanation-box">
              <strong>How this is calculated:</strong>
              <p>{explanation}</p>
            </div>
          )}

          {records && records.length > 0 && (
            <div className="records-section">
              <strong>Underlying Records ({records.length}):</strong>
              <div className="records-list">
                <pre>{JSON.stringify(records, null, 2)}</pre>
              </div>
            </div>
          )}

          {records && records.length === 0 && (
            <div className="no-records">
              No records found for this metric.
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-close" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default DataSourceModal;
